<script setup lang="ts">
import { useHomeRoute } from '../composables/useHomeRoute';
import AppLogo from './AppLogo.vue';

const { push: navigateToDashboard } = useHomeRoute();
</script>

<template>
    <div class="auth-layout surface-0">
        <div
            class="auth-layout-content-wrapper flex align-items-center justify-content-between flex-column h-screen"
        >
            <div
                class="auth-layout-header align-items-center justify-content-center w-full flex-0 md:w-6 h-full text-center py-6 px-4"
            >
                <a
                    class="my-6"
                    style="cursor: pointer"
                    @click="navigateToDashboard"
                >
                    <AppLogo full />
                </a>
            </div>
            <div class="auth-layout-content mb-auto">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>
